/**
 * 长段时间轴
 * 以60s=60000ms为一个长段
 */
var LongSegLine = /** @class */ (function () {
    function LongSegLine() {
        this.list = [];
    }
    /** 添加一条弹幕 */
    LongSegLine.prototype.add = function (dan) {
        var startmin = Math.floor(dan.start / 60000); // 获取开始时所在的分钟段
        var endmin = Math.floor(dan.end / 60000); // 获取结束时所在的分钟段
        for (var m = startmin; m <= endmin; m++) {
            this.listAdd(m, dan); // 弹幕存在的任何长段都有该弹幕对象的指针
        }
    };
    /** 删除一条弹幕 */
    LongSegLine.prototype.remove = function (dan) {
        var _a, _b;
        var startmin = Math.floor(dan.start / 60000); // 获取开始时所在的分钟段
        var endmin = Math.floor(dan.end / 60000); // 获取结束时所在的分钟段
        for (var m = startmin; m <= endmin; m++) { // 在该时段内逐段查找弹幕位置并依次删除
            var i = (_a = this.list[m]) === null || _a === void 0 ? void 0 : _a.indexOf(dan);
            i && i != -1 && ((_b = this.list[m]) === null || _b === void 0 ? void 0 : _b.splice(i, 1));
        }
    };
    /** 获取一个分段的弹幕 */
    LongSegLine.prototype.getSegList = function (i) {
        return this.listGet(i);
    };
    /** 清空时间轴 */
    LongSegLine.prototype.clear = function () {
        this.list = [];
    };
    LongSegLine.prototype.listAdd = function (i, item) {
        var _a;
        if (!this.list[i]) {
            this.list[i] = [];
        }
        (_a = this.list[i]) === null || _a === void 0 ? void 0 : _a.push(item);
    };
    LongSegLine.prototype.listGet = function (i) {
        return this.list[i] || [];
    };
    return LongSegLine;
}());
export { LongSegLine };
//# sourceMappingURL=LongSegLine.js.map